import { withConfirm } from 'react-redux-confirm';
import ConfirmModal from './ConfirmModal';

const ConfirmModalContainer = withConfirm(ConfirmModal) as any;

export default ConfirmModalContainer;
